const REQUIRED_ADAPTER_INTERFACE = {
  initialize: 'initialize(options) to initialize tracker instance if necessary',
  getTrackerInstance: 'getTrackerInstance() to return tracker instance',
  trackEvent: 'trackEvent(eventName, properties) to send event tracker',
};

function validateAdapter(adapter) {
  if (!adapter) {
    throw new Error('adapter null or undefined');
  }
  Object.keys(REQUIRED_ADAPTER_INTERFACE).forEach(property => {
    if (!adapter[property]) {
      throw new Error(`missing ${REQUIRED_ADAPTER_INTERFACE[property]}`);
    }
  });
}

/**
 * Validate and initialize tracker adapter
 * @param {object} adapter - Adapter object following required interfaces as provided in `adapters` directory
 * @param {object} options - Options for initialize() method in adapter
 * @returns
 */
export default function initializeTracker(adapter, options) {
  validateAdapter(adapter);
  adapter.initialize(options);
  return adapter;
}
